module.exports = __webpack_public_path__ + "img/4.e727d926.jpg";